import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import ArticlePage from "../pages/article/page";
import AboutPage from "../pages/about/page";
import ScrollToTop from "../components/feature/ScrollToTop";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <Home />
      </>
    ),
  },
  {
    path: "/category/:slug",
    element: (
      <>
        <ScrollToTop />
        <CategoryPage />
      </>
    ),
  },
  {
    path: "/article/:id",
    element: (
      <>
        <ScrollToTop />
        <ArticlePage />
      </>
    ),
  },
  {
    path: "/about",
    element: (
      <>
        <ScrollToTop />
        <AboutPage />
      </>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;